import React, {Fragment, useEffect, useState} from "react";
import {fetchPosts} from "../../../redux/actions";
import {Card, Loader, Pagination, Segment} from "semantic-ui-react";

import {PostCard} from './PostCard';
import {Featured} from './Featured';

export const Posts = ({from, city, path, location, category, page}) => {

    const [posts, setPosts] = useState([]);
    const [pagination, setPagination] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const first = posts[0] || {};

    const hash = window.location.hash.substr(1);
    const values = new URLSearchParams(hash);

    const {id: cityId} = city;

    useEffect(() => {

        const fetchData = async () => {

            // start loading
            setIsLoading(true);

            // clear all
            await setPosts([]);
            await setPagination({});

            try {

                window.scrollTo(0, 0);

                // get posts
                const result = await fetchPosts(cityId, category, page, from);

                // set posts
                await setPosts(result.data);
                await setPagination(result.pagination);

            } catch (e) {

                // show errors
                console.log('error', e);
            }

            // stop loading
            setIsLoading(false);
        };

        // noinspection JSIgnoredPromiseFromCall
        fetchData();

    }, [cityId, page, category]);

    return (
        <Fragment>
            <Loader active={isLoading} inline/>
            {
                parseInt(page) === 1 &&
                <Featured
                    post={first}
                    read={false}
                    path={path}
                />
            }
            <Card.Group stackable itemsPerRow={3}>
                {
                    posts.slice(parseInt(page) === 1 ? 1 : 0).map((post) => {

                        return (
                            <PostCard
                                key={`post-${post.id}`}
                                post={post}
                                path={path}
                            />
                        );
                    })
                }
            </Card.Group>
            {
                pagination.page_count > 1 && <Segment basic textAlign={"center"}>
                    <Pagination
                        boundaryRange={0}
                        defaultActivePage={pagination.current_page}
                        ellipsisItem={null}
                        firstItem={null}
                        lastItem={null}
                        siblingRange={2}
                        totalPages={pagination.page_count}
                        onPageChange={(e, {activePage}) => {
                            e.preventDefault();
                            values.set('page', activePage);
                            window.location.hash = values.toString();
                        }}
                    />
                </Segment>
            }
        </Fragment>
    );
};

